"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphqlToAssetTransform = void 0;
const graphqlToAssetTransform = (params) => {
    const { aggDef, result, flattenRelationships } = params;
    //basically return what we're given, but change any Geography or anchoredLine types to pull out the geojson property
    if (!aggDef || !result) {
        return result;
    }
    const newResult = Object.assign({}, result);
    // Flatten GeoJSON props
    const geoProps = aggDef.propertyDefinitions.filter(prop => ['Geography', 'AnchoredLine'].includes(prop.type));
    geoProps.forEach(prop => {
        var _a;
        newResult[prop.field] = (_a = result[prop.field]) === null || _a === void 0 ? void 0 : _a.geojson;
    });
    if (flattenRelationships) {
        // Flatten relationship types
        const relationshipProps = aggDef.propertyDefinitions.filter(prop => prop.isRelationship && (prop.relationshipType === 'ONE_TO_ONE' || prop.relationshipType === 'ONE-TO-ONE'));
        relationshipProps.forEach(prop => {
            const curValue = result[prop.field];
            newResult[prop.field] = (curValue === null || curValue === void 0 ? void 0 : curValue.id) || result[prop.field + 'Id'] || curValue;
        });
    }
    return newResult;
};
exports.graphqlToAssetTransform = graphqlToAssetTransform;
//# sourceMappingURL=aggregate.js.map